import React from 'react';
import {
  TipoColumnaMetadato, IMetadatoAsociado,
  IValorMetadato, $_, DATETIME_ERROR_STYLE,
  onFormatDate, DatePickerStrings, IDocumento, getFileName, truncate,
  getFileExtension, showError,
  DataTableRequest, DataTablesResponse,
  IOpcionSeleccionable
} from "./base";
import { IComboBoxOption, Fabric, TooltipHost, DatePicker, DayOfWeek, DirectionalHint, Checkbox, TextField, ComboBox, IColumn, IContextualMenuItem, CommandBar, DetailsList, SelectionMode } from "@fluentui/react";
import { Link, Icon } from "@fluentui/react";
import { ICity, ICountry, IDepartment } from '@ioip/archivox/lib';

//#region Editor metadatos

export interface ILayoutEditorComponentProps {

  mode: 'edit' | 'exe';

  /**
   * Servicio web a utilizar para obtener los metadatos asociados al trámite
   */
  editMetadataService: (idTramite: number) => Promise<IMetadatoAsociado[]>;

  /**
   * Servicio web a utilizar para obtener los metadatos asociados al trámite
   * incluidas las opciones de lista desplegable
   */
  executableMetadataService: (idTramite: number) => Promise<IMetadatoAsociado[]>;

  /**
   * Función a ejecutar cuando se cambie el valor de un metadato
   */
  onChangeValues: (values: IValorMetadato[]) => void;

  getCitiesService: () => Promise<ICity[]>;

  getDepartmentsService: () => Promise<IDepartment[]>;

  getCountriesService: () => Promise<ICountry[]>;

  getCategoryMetadataService: (name: string) => Promise<any>;

  getMetadataOptionsService: (idMetadato: number) => Promise<IOpcionSeleccionable[]>;

  /**
   * Servicio a utilizar para la lectura de metadatos personalizados cuando son de tipo ExternalMetadata
   */
  readExternalMetadataService: (applicatin: string, className: string) => Promise<any[]>;

  /**
   * Servicio a utilizar para la lectura de metadatos personalizados
   */
  executeCustomCodeService: (applicatin: string, className: string, data: { [ key: string ]: any }) => Promise<string>;

  /**
   * Servicio encargado de consultar contactos
   */
  getContactsService: (request: DataTableRequest) => Promise<DataTablesResponse>;

  scope: 'ventanilla' | 'mesa de ayuda' | 'web';

  idObjeto: number;

  idObjetoAsUrlParam: boolean;

}

export interface IEditorMetadatosComponentProps {
  metadatos: IMetadatoAsociado[];
  values?: IValorMetadato[];
  onInitialize?: (component: EditorMetadatosComponent) => void;
  onChangeValues?: (values: IValorMetadato[]) => void;
  searchMode: boolean;
  readonly?: boolean;
  /**
   * Establece si se deben renderizar solo los metadatos marcados como "Mostrar"
   */
  renderOnlyItemsMarkAsShow: boolean;
  /**
   * Función a ejecutar al momento de renderizar un metadato.
   * Permite establecer si se debe renderizar
   */
  onCheckRender?: (metadata: IMetadatoAsociado) => boolean;

  idTramite?: number;

  errors: { [ key: string ]: string }

  onChangeErrors: (errors: { [ key: string ]: string }) => void;
}

export interface IEditorMetadatosComponentState { idTramite: number; metadatos: IMetadatoAsociado[]; errors: { [ key: string ]: string }; values: IValorMetadato[]; }
export interface IControl { type: string; label?: string; childrens?: IControl[]; colLg?: number; colMd?: number; onChange?(value: string | number): void; }
export interface IGrupoMetadato { idCategoria: number; nombreCategoria: string; metadatos: IMetadatoAsociado[]; }

export class EditorMetadatosComponent extends React.Component<IEditorMetadatosComponentProps, IEditorMetadatosComponentState> {

  private tempErrors: { [ key: string ]: any } = {};

  constructor(props: IEditorMetadatosComponentProps) {
    super(props);
    this.state = {
      metadatos: this.props.metadatos,
      errors: {},
      values: this.props.values || [],
      idTramite: 0
    };
    if (this.props.onInitialize) {
      this.props.onInitialize(this);
    }
  }

  public render(): JSX.Element {
    const categories = this._group(this.state.metadatos);
    return (
      <Fabric>
        {
          categories.map((category: IGrupoMetadato) => this.renderCategory(category))
        }
      </Fabric >
    )
  }

  public renderCategory(categoria: IGrupoMetadato): JSX.Element {

    // Filtrar los metadatos a mostrar
    let cells = categoria
      .metadatos
      .filter(o => this.props.renderOnlyItemsMarkAsShow ? o.Mostrar : true);

    // Ejecutar filtrado personalizado
    if (this.props.onCheckRender) {
      cells = cells.filter(o => this.props.onCheckRender(o) === true);
    }

    // Renderizar
    return <Fabric key={`category-${categoria.idCategoria}`}>
      <div className="ms-Grid-row">
        <div className={`ms-Grid-col ms-sm12 ms-md12 ms-lg12`}>
          <p className='ms-fontSize-l ms-fontColor-themePrimary'>{categoria.nombreCategoria}</p>
        </div>
      </div>
      <div className="ms-Grid-row">
        {
          cells
            .map((metadato: IMetadatoAsociado) => this.renderCell(metadato))
        }
      </div>
    </Fabric>

  }

  public renderCell(metadato: IMetadatoAsociado): JSX.Element {

    // Verificar si el metadato se debe o no renderizar
    let show = !this.props.searchMode || (this.props.searchMode && metadato.IdTipoColumnaMetadato != TipoColumnaMetadato.Nota && metadato.Busqueda);

    // Evaluar condición
    if (show) {
      if (!$_.isNull(metadato.ReglaVisible) && metadato.ReglaVisible !== '') {
        show = this._evalRule(metadato.ReglaVisible);
      }
    }

    // Evaluar requerido
    if (metadato.ReglaRequerido) {
      const value = this._evalRule(metadato.ReglaRequerido);
      metadato.Requerido = value;
    }

    // Establecer el ancho de la columna
    //const className = `ms-Grid-col ms-lg${metadato.TamanoCompleto ? '12' : '6'} ms-md${metadato.TamanoCompleto ? '12' : '6'} ms-sm12`;

    // Renderizar
    return <Fabric key={'cell-' + metadato.IdMetadato}>
      {
        show && <div style={metadato.IdTipoColumnaMetadato == TipoColumnaMetadato.SiNo ? { 'paddingTop': '8px' } : {}}>
          <TooltipHost content={metadato.Descripcion} directionalHint={DirectionalHint.bottomLeftEdge}>
            {
              this.props.renderOnlyItemsMarkAsShow
                ? (metadato.Mostrar && this.renderControl(metadato))
                : this.renderControl(metadato)
            }
          </TooltipHost>
        </div>
      }
    </Fabric>
  }

  /**
   * Renderiza el control correspondiente a un metadato
   * @param metadato 
   */
  public renderControl(metadato: IMetadatoAsociado): JSX.Element {
    switch (metadato.IdTipoColumnaMetadato) {
      case TipoColumnaMetadato.Texto:
        return this.renderText(metadato);
      case TipoColumnaMetadato.Nota:
        return this.renderNota(metadato);
      case TipoColumnaMetadato.Seleccion:
      case TipoColumnaMetadato.Usuario:
      case TipoColumnaMetadato.Pais:
      case TipoColumnaMetadato.Departamento:
      case TipoColumnaMetadato.Ciudad:
      case TipoColumnaMetadato.Custom:
        return this.renderDropDownList(metadato);
      case TipoColumnaMetadato.Fecha:
        return this.renderDate(metadato);
      case TipoColumnaMetadato.SiNo:
        return this.renderBoolean(metadato);
      case TipoColumnaMetadato.ExpresionRegular:
        return this.renderRegularExpression(metadato);
      case TipoColumnaMetadato.Numero:
        return this.renderNumber(metadato);
      case TipoColumnaMetadato.Moneda:
        return this.renderMoney(metadato);
      default:
        throw 'El tipo de metadato no es valido ' + JSON.stringify(metadato);
    }
  }

  public renderText(metadato: IMetadatoAsociado): JSX.Element {
    return <TextField
      label={metadato.Nombre}
      required={metadato.Requerido}
      maxLength={metadato.LongitudMaxima || 1024}
      value={this._getValue<string>(metadato.IdMetadato)}
      errorMessage={this.state.errors[ metadato.IdMetadato ]}
      disabled={this.props.readonly}
      onChange={(_, value) => {
        this._setValue(metadato.IdMetadato, value);
      }}
    />;
  }

  public renderNota(metadato: IMetadatoAsociado): JSX.Element {
    return <TextField
      label={metadato.Nombre}
      required={metadato.Requerido}
      multiline={true}
      maxLength={metadato.LongitudMaxima || 2048}
      errorMessage={this.state.errors[ metadato.IdMetadato ]}
      value={this._getValue<string>(metadato.IdMetadato)}
      disabled={this.props.readonly}
      onChange={(_, value) => {
        this._setValue(metadato.IdMetadato, value);
      }}
    />;
  }

  public renderDropDownList(metadato: IMetadatoAsociado): JSX.Element {

    const selectedKey: number = Number(this._getValue<string>(metadato.IdMetadato));
    let items = this._getComboBoxOptions(metadato);
    // Filtrar elementos
    if (!$_.isNullOrEmpty(metadato.ReglaListaDesplegable)) {
      const data = this._getMetadataValues();
      items = this._processDropDownListOptions(metadato, items, data, this.state.idTramite);
    }
    return <ComboBox
      label={metadato.Nombre}
      required={metadato.Requerido}
      useComboBoxAsMenuWidth={true}
      autoComplete='on'
      errorMessage={this.state.errors[ metadato.IdMetadato ]}
      selectedKey={selectedKey}
      options={items}
      disabled={this.props.readonly}
      onChange={(ev: any, value: IComboBoxOption, e: any) => {
        this._setValue(metadato.IdMetadato, value.key);
      }}
    />;
  }

  private _processDropDownListOptions(metadato: IMetadatoAsociado, items: IComboBoxOption[], data: { [ key: string ]: any }, idTramite: number): IComboBoxOption[] {
    const func: Function = new Function('items', '$', 'idTramite', metadato.ReglaListaDesplegable);
    const result = func(items, data, idTramite);
    console.log(metadato.Nombre, result);
    return result;
  }

  public renderDate(metadato: IMetadatoAsociado): JSX.Element {
    return <Fabric>
      <DatePicker
        firstDayOfWeek={DayOfWeek.Sunday}
        strings={DatePickerStrings}
        placeholder='dd/MM/yyyy'
        isRequired={metadato.Requerido}
        label={metadato.Nombre}
        formatDate={onFormatDate}
        onSelectDate={(value: Date) => {
          this._setValue(metadato.IdMetadato, value);
        }}
        disabled={this.props.readonly}
        value={this._getValue<Date>(metadato.IdMetadato)} />
      <small style={DATETIME_ERROR_STYLE}>{this.state.errors[ metadato.IdMetadato ]}</small>
    </Fabric>

  }

  public renderBoolean(metadato: IMetadatoAsociado): JSX.Element {
    return <Checkbox
      label={metadato.Nombre}
      checked={this._getValue<boolean>(metadato.IdMetadato)}
      disabled={this.props.readonly}
      onChange={(event, value) => {
        this._setValue(metadato.IdMetadato, value);
      }} />;
  }

  public renderRegularExpression(metadato: IMetadatoAsociado): JSX.Element {
    return <TextField
      label={metadato.Nombre}
      required={metadato.Requerido}
      maxLength={512}
      multiline={false}
      errorMessage={this.state.errors[ metadato.IdMetadato ]}
      value={this._getValue<string>(metadato.IdMetadato)}
      disabled={this.props.readonly}
      onChange={(_, value) => {
        this._setValue(metadato.IdMetadato, value);
      }} />
  }

  public renderNumber(metadato: IMetadatoAsociado): JSX.Element {
    return <NumberTextField
      initialValue={''}
      label={metadato.Nombre}
      required={metadato.Requerido}
      maxLength={metadato.ValorMaximo ? Math.ceil(metadato.ValorMaximo / 10) : 10}
      onChanged={(value) => {
        this._setValue(metadato.IdMetadato, value);
      }}
      errorMessage={this.state.errors[ metadato.IdMetadato ]}
      disabled={this.props.readonly}
      value={this._getValue<number>(metadato.IdMetadato)}
    />
  }

  public renderMoney(metadato: IMetadatoAsociado): JSX.Element {
    return <NumberTextField
      initialValue={''}
      label={metadato.Nombre}
      required={metadato.Requerido}
      maxLength={metadato.ValorMaximo ? Math.ceil(metadato.ValorMaximo / 10) : 10}
      onChanged={(value) => {
        this._setValue(metadato.IdMetadato, value);
      }}
      errorMessage={this.state.errors[ metadato.IdMetadato ]}
      disabled={this.props.readonly}
      value={this._getValue<number>(metadato.IdMetadato)}
    />
  }

  private _isDropDownListField(metadata: IMetadatoAsociado): boolean {
    return metadata.IdTipoColumnaMetadato === TipoColumnaMetadato.Seleccion
      || metadata.IdTipoColumnaMetadato === TipoColumnaMetadato.Pais
      || metadata.IdTipoColumnaMetadato === TipoColumnaMetadato.Departamento
      || metadata.IdTipoColumnaMetadato === TipoColumnaMetadato.Ciudad
      || metadata.IdTipoColumnaMetadato === TipoColumnaMetadato.TipoIdentificacion
      || metadata.IdTipoColumnaMetadato === TipoColumnaMetadato.Custom;
  }

  private _getMetadataValues(): { [ key: string ]: any } {
    const metadata = this.state.metadatos;
    const data = {};
    for (var i = 0; i < metadata.length; i++) {
      data[ metadata[ i ].IdMetadato ] = metadata[ i ];
      data[ metadata[ i ].Nombre ] = metadata[ i ];
      const value = this.state.values.filter(o => o.IdMetadato === metadata[ i ].IdMetadato)[ 0 ];

      if (value) {
        data[ metadata[ i ].IdMetadato ].Value = value.Valor;
        data[ metadata[ i ].Nombre ].Value = value.Valor;

        // Si el metadato es de tipo lista desplegable se debe establecer el texto de la opción seleccionada
        if (this._isDropDownListField(metadata[ i ])) {
          const option = data[ metadata[ i ].IdMetadato ].Opciones.filter(o => o.IdOpcionListaDesplegableMetadato === value.Valor)[ 0 ];
          const text = option !== undefined ? option.Nombre : '';
          data[ metadata[ i ].IdMetadato ].Text = text;
          data[ metadata[ i ].Nombre ].Text = text;
        }
      }
    }
    return data;
  }

  private _evalRule(code: string): boolean {

    const stringIsNullOrEmpty = (s: string): boolean => {
      return s === undefined || s === null || s === '';
    }

    // Si el código personalizado está vacio, se retorna true
    if (stringIsNullOrEmpty(code)) {
      return true;
    }

    const func = new Function('$', 'return ' + code);
    const data = this._getMetadataValues();
    return func(data);

  }

  private _getValue<T>(idMetadato: number): T {
    const value: IValorMetadato = this.state.values.filter(o => o.IdMetadato === idMetadato)[ 0 ];
    const dataType = this.state.metadatos.filter(o => o.IdMetadato == idMetadato)[ 0 ];
    if (value !== undefined) {
      if (dataType && dataType.IdTipoColumnaMetadato == TipoColumnaMetadato.Fecha) {
        return (new Date(value.Valor as any) as any);
      } else {
        return (value.Valor as any) as T;
      }
    }
    return undefined;
  }

  private _setValue(idMetadato: number, value: any): void {
    let values: IValorMetadato[] = this.state.values.slice();
    let metadato: IValorMetadato = values.filter(o => o.IdMetadato === idMetadato)[ 0 ];
    const metadatoAsociado = this.state.metadatos.filter(o => o.IdMetadato === idMetadato)[ 0 ];
    if (metadato === undefined) {
      metadato = {
        IdMetadato: idMetadato,
        IdExpediente: 0,
        IdDocumentoExpediente: 0,
        IdOpcionListaDesplegableMetadato: 0,
        IdValorMetadato: 0,
        Valor: value,
        Nombre: metadatoAsociado !== undefined ? metadatoAsociado.Nombre : '',
        Codigo: '',
        CategoriaMetadato: ''
      }
      values.push(metadato);
    }
    metadato.Valor = value;
    this.setState({ values });
    if (this.props.onChangeValues) {
      this.props.onChangeValues(values);
    }
  }

  private _getComboBoxOptions(metadato: IMetadatoAsociado): IComboBoxOption[] {
    let options: IComboBoxOption[] = [];
    if (metadato.Opciones) {

      options = metadato.Opciones.map((o: any) => ({
        key: o.IdOpcionListaDesplegableMetadato || o.key,
        text: o.Nombre || o.text
      }));

      // Filtrar elementos en caso de ser un combobox dependiente
      if (metadato.ReglaListaDesplegable) {

      }

    }
    return options;
  }

  private _sort(values: any[], property: string): any[] {
    const result = values.sort((a: any, b: any): number => {
      if (a[ property ] < b[ property ]) {
        return -1;
      }
      if (a[ property ] > b[ property ]) {
        return 1;
      }
      else {
        return 0;
      }
    });
    return result;
  }

  private _group(values: IMetadatoAsociado[]): IGrupoMetadato[] {
    let groups: IGrupoMetadato[] = [];
    this._sort(values, 'Orden').forEach(metadato => {
      if (!this.props.searchMode || (this.props.searchMode && metadato.IdTipoColumnaMetadato != TipoColumnaMetadato.Nota && metadato.Busqueda)) {
        let group: IGrupoMetadato = groups.filter(o => o.idCategoria === metadato.IdCategoriaMetadato)[ 0 ];
        if (group === undefined) {
          group = {
            idCategoria: metadato.IdCategoriaMetadato,
            nombreCategoria: metadato.CategoriaMetadato,
            metadatos: [],
          }
          groups.push(group);
        }
        group.metadatos.push(metadato);
      }
    });
    return this._sort(groups, 'nombreCategoria');
  }

  /**
   * Establece un error de validación
   * @param idMetadato ID del metadato que tiene errores de validación
   * @param errorMessage Mensaje de error
   */
  private _setError(idMetadato: number, errorMessage: string) {
    this.tempErrors[ idMetadato ] = errorMessage;
    this.setState({
      errors: this.tempErrors
    });
  }

  public validate(): boolean {

    let hasError: boolean = false;
    for (let i = 0; i < this.props.metadatos.length; i++) {
      const metadato: IMetadatoAsociado = this.props.metadatos[ i ];
      if (metadato.Mostrar === true) {
        const _value: IValorMetadato = this.state.values.filter(o => o.IdMetadato === metadato.IdMetadato)[ 0 ] || {
          IdMetadato: metadato.IdMetadato,
          IdExpediente: 0,
          IdDocumentoExpediente: 0,
          IdOpcionListaDesplegableMetadato: 0,
          IdValorMetadato: 0,
          Valor: '',
          Codigo: '',
          CategoriaMetadato: '',
          Nombre: ''
        };

        // Evaluar campos requeridos
        if (metadato.Requerido) {

          // Evaluar campos de selección
          if (metadato.IdTipoColumnaMetadato === TipoColumnaMetadato.Seleccion) {
            const value: number = Number(_value.Valor);
            if (value === undefined || value <= 0) {
              this._setError(metadato.IdMetadato, 'Campo requerido');
              hasError = true;
              continue;
            }
          }

          if (metadato.IdTipoColumnaMetadato === TipoColumnaMetadato.Moneda) {
            const value: number = Number(_value.Valor);
            if (value === undefined || value <= 0) {
              this._setError(metadato.IdMetadato, 'Campo requerido');
              hasError = true;
              continue;
            }
          }

          if (metadato.IdTipoColumnaMetadato === TipoColumnaMetadato.Usuario) {
            const value: number = Number(_value.Valor);
            if (value === undefined || value <= 0) {
              this._setError(metadato.IdMetadato, 'Campo requerido');
              hasError = true;
              continue;
            }
          }

        }

        // Evaluar campo de texto y nota
        if (metadato.IdTipoColumnaMetadato === TipoColumnaMetadato.Texto || metadato.IdTipoColumnaMetadato === TipoColumnaMetadato.Nota || metadato.IdTipoColumnaMetadato === TipoColumnaMetadato.ExpresionRegular) {
          if (metadato.Requerido && (_value.Valor == null || _value.Valor.trim().length === 0)) {
            this._setError(metadato.IdMetadato, 'Campo requerido');
            hasError = true;
            continue;
          }

          if (metadato.LongitudMinima && metadato.LongitudMinima > 0) {
            if (_value.Valor.length < metadato.LongitudMinima) {
              this._setError(metadato.IdMetadato, `Minimo se permiten ${metadato.LongitudMinima} carácteres`);
              hasError = true;
              continue;
            }
          }
          if (metadato.LongitudMaxima && metadato.LongitudMaxima > 0) {
            if (_value.Valor.length > metadato.LongitudMaxima) {
              this._setError(metadato.IdMetadato, `Máximo se permiten ${metadato.LongitudMaxima} carácteres`);
              hasError = true;
              continue;
            }
          }

          // Evaludar expresión regular
          if (metadato.IdTipoColumnaMetadato === TipoColumnaMetadato.ExpresionRegular) {
            const exp: RegExp = new RegExp(metadato.ExpresionRegular || '');
            if (exp.exec(_value.Valor) == null) {
              this._setError(metadato.IdMetadato, `Valor no valido`);
              hasError = true;
              continue;
            }
          }

        }

        // Evaluar campo numérico
        if (metadato.IdTipoColumnaMetadato === TipoColumnaMetadato.Numero || metadato.IdTipoColumnaMetadato === TipoColumnaMetadato.Moneda) {
          const value = isNaN(Number(_value.Valor)) ? 0 : Number(_value.Valor);
          if (metadato.Requerido && isNaN(Number(_value.Valor))) {
            this._setError(metadato.IdMetadato, `Campo requerido`);
            hasError = true;
            continue;
          }

          if (metadato.ValorMinimo && metadato.ValorMinimo > 0) {
            if (value < metadato.ValorMinimo) {
              this._setError(metadato.IdMetadato, `El valor minimo permitido es ${metadato.ValorMinimo}`);
              hasError = true;
              continue;
            }
          }
          if (metadato.ValorMaximo && metadato.ValorMaximo > 0) {
            if (value > metadato.ValorMaximo) {
              this._setError(metadato.IdMetadato, `El valor máximo permitido es ${metadato.ValorMaximo}`);
              hasError = true;
              continue;
            }
          }
        }

        // Evaluar fechas
        if (metadato.IdTipoColumnaMetadato === TipoColumnaMetadato.Fecha) {

          if (metadato.Requerido && (_value.Valor == null || !(_value.Valor as any instanceof Date))) {
            this._setError(metadato.IdMetadato, `Campo requerido`);
            hasError = true;
            continue;
          }

          if (metadato.FechaMaxima) {
            const max: Date = new Date(metadato.FechaMaxima as any);
            if (_value.Valor as any > max) {
              this._setError(metadato.IdMetadato, `La fecha no puede ser mayor a ${onFormatDate(max)}`);
              hasError = true;
              continue;
            }
          }

          if (metadato.FechaMinima) {
            const min: Date = new Date(metadato.FechaMinima as any);
            if (_value.Valor as any < min) {
              this._setError(metadato.IdMetadato, 'La fecha no puede ser menor a ' + onFormatDate(min));
              hasError = true;
              continue;
            }
          }

        }

        this._setError(metadato.IdMetadato, '');

      }
    }
    return !hasError;
  }

  public getValues(): IValorMetadato[] {
    return this.state.values;
  }

  public componentWillReceiveProps(nextProps: IEditorMetadatosComponentProps): void {
    this.setState({
      values: nextProps.values || [],
      metadatos: nextProps.metadatos || [],
      idTramite: nextProps.idTramite || 0,
      errors: nextProps.errors
    });
  }

}

//#endregion

//#region Solicitud información

//#endregion

//#region NumberTextField

export interface INumberTextFieldProps {
  label: string;
  initialValue: string;
  required?: boolean;
  value: string | number;
  onChanged?: (newValue: number) => void;
  errorMessage?: string;
  maxLength?: number;
  disabled?: boolean;
  borderless?: boolean;
}

export interface INumberTextFieldState {
  value: string;
  errorMessage?: string;
}

export class NumberTextField extends React.Component<INumberTextFieldProps, INumberTextFieldState> {

  constructor(props: INumberTextFieldProps) {
    super(props);
    this.state = {
      value: props.value ? String(props.value) : props.initialValue
    };
  }

  public render(): JSX.Element {
    return (
      <TextField
        label={this.props.label}
        value={this.state.value}
        required={this.props.required}
        errorMessage={this.state.errorMessage}
        maxLength={this.props.maxLength}
        disabled={this.props.disabled}
        borderless={this.props.borderless || false}
        onChange={this._onChange.bind(this)} />
    );
  }

  public componentWillReceiveProps(nextProps: INumberTextFieldProps): void {
    if (isNaN(Number(nextProps.value)) || nextProps.value === 0) {
      this.setState({ value: this.props.initialValue });
    } else {
      this.setState({ value: String(nextProps.value) });
    }
    this.setState({ errorMessage: nextProps.errorMessage });
  }

  private _onChange(ev: any, value: string): void {
    value = value.split('').filter(o => !isNaN(Number(o))).join('');
    this.setState({ value });
    if (this.props.onChanged) {
      this.props.onChanged(Number(value));
    }
  }
}

//#endregion

export interface IDropZoneComponentProps {
  onDrop?: (files: File[]) => void | Promise<void>;
  onClear?: () => void | Promise<void>;
  onRemove?: (item: IDocumento) => void | Promise<void>;
  onItemClick?: (item: IDocumento) => Promise<void>;
  allowedExtensions?: string;
  useDefaultExtensions?: boolean;
  multiple?: boolean;
  text?: string;
  disabled?: boolean;
  columns?: IColumn[];
  items?: IDocumento[];
  onChange?: (item: IDocumento[]) => void;
  customItems?: any[];
  hideDetailsOnEmpty?: boolean;
  showCustomItems?: boolean;
  maxLength?: number;
  onAllowRemove?: (item: IDocumento) => boolean;
  custom?: boolean;
}

export interface IDropZoneComponentState {
  style?: React.CSSProperties;
  defaultColumns: IColumn[];
  customColumns: IColumn[];
  items: IDocumento[];
  allowedExtensions: string[];
  maxLength: number;
}

export class DropZoneComponent extends React.Component<IDropZoneComponentProps, IDropZoneComponentState> {

  private get _columns(): IColumn[] {
    if (this.props.custom) {
      return this.state.customColumns;
    } else {
      return this.state.defaultColumns;
    }
  }

  constructor(props: any) {
    super(props);
    this.state = {
      ...this._defaultState(),
      maxLength: props.maxLength || 1024,
    };
  }

  public async componentDidMount(): Promise<void> {
    if (this.props.useDefaultExtensions === true) {

    } else {
      if (this.props.allowedExtensions) {
        this.setState({ allowedExtensions: this.props.allowedExtensions.split(',').map(o => o.toLowerCase().trim()) });
      }
      else {
        this.setState({ allowedExtensions: [] });
      }
    }
  }

  public _buildCommandBar(): IContextualMenuItem[] {
    return (
      [
        {
          key: 'Seleccionar archivos',
          name: 'Seleccionar archivos',
          iconProps: { iconName: 'OpenFile' },
          title: 'Permite seleccionar archivos del equipo para cargar al sistema.' + (this.state.maxLength ? ' El tamaño máximo permitido por archivo es de ' + truncate(this.state.maxLength / 1048576) + ' MB' : ''),
          onClick: (this._openDialog as any).bind(this, true)
        }
      ]
    );
  }

  public render(): JSX.Element {
    return (
      <Fabric>
        {
          (this.props.disabled === undefined || this.props.disabled === false) && <CommandBar items={this._buildCommandBar()} className='command-bar-1' />
        }
        <div className='md-Grid-row' onDrop={this._onDrop.bind(this)} onDragOver={this._onDragOver.bind(this)}>
          {
            this.state.items.length > 0 && <div className='ms-Grid-col ms-sm12 ms-md12 ms-lg12'>
              <DetailsList
                items={this.state.items}
                selectionMode={this.props.disabled ? SelectionMode.none : SelectionMode.multiple}
                columns={this._columns} />
            </div>
          }
          {
            this.state.items.length === 0 && <div className='ms-Grid-col ms-sm12 ms-md12 ms-lg12' style={{ padding: '15px', textAlign: 'center' }}>
              No hay información para mostrar
            </div>
          }
        </div>
      </Fabric >
    );
  }

  public componentWillReceiveProps(nextProps: IDropZoneComponentProps): void {
    if (this.props.custom === true) {
      this.setState({
        items: nextProps.customItems || [],
        customColumns: nextProps.columns || [],
        maxLength: nextProps.maxLength
      });
    }
    else {
      this.setState({
        items: nextProps.items || [],
        customColumns: nextProps.columns || [],
        maxLength: nextProps.maxLength
      });
    }
  }

  private _openDialog(): void {
    if (!this.props.disabled) {
      const input: HTMLInputElement = document.createElement('input');
      input.type = 'file';
      input.accept = this.state.allowedExtensions.join(',');
      input.multiple = this.props.multiple;
      input.click();
      input.addEventListener('change', () => {
        if (input.files && input.files.length > 0) {
          this._processFiles(input.files);
        }
      });
    }
  }

  private _onDrop(e: any): void {
    e.preventDefault();
    if (!this.props.disabled) {
      if (e && e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
        this._processFiles(e.dataTransfer.files);
      }
    }
  }

  private async _processFiles(filesToProcess: FileList): Promise<void> {
    if (filesToProcess.length > 0) {
      let errorMessage = '';

      // Obtener los elementos actuales
      let items = this.state.items.slice();
      const files: File[] = [];

      // Prevenir que se adicione mas de un archivo cuando la opción de multiple es falso
      if (!this.props.multiple && items.length > 0) {
        items = [];
      }

      const max = this.props.multiple ? filesToProcess.length : 1;
      for (let i = 0; i < max; i++) {
        const file = filesToProcess[ i ];
        const nombre = getFileName(file.name);
        const extension = getFileExtension(file.name);

        // Verificar que los nombres de los archivos no se repitan y que el tipo sea valido
        if (this.state.allowedExtensions.indexOf(file.type.toLowerCase()) < 0 && this.state.allowedExtensions.indexOf(extension.toLowerCase()) < 0) {
          errorMessage = `El tipo de archivo no es permitido`;
          break;
        }

        // Verificar que el archivo no se haya agregado previamente
        if (items.filter(o => o.Nombre.trim().toUpperCase() === file.name.trim().toUpperCase()).length === 0) {

          // Verificar que el archivo no supere el tamaño permitido
          if (this.state.maxLength) {
            if (file.size > this.state.maxLength) {
              errorMessage = `El tamaño de los archivos no deben superara ${truncate((this.state.maxLength / 1024))} Kb`;
              break;
            }
          }

          items.push({
            IdDocumentoRadicadoEntrada: 0,
            IdAnexoDocumentoExpediente: 0,
            IdDocumentoRadicadoSalida: 0,
            IdDocumentoComunicadoInterno: 0,
            IdComunicadoInterno: 0,
            IdDocumentoExpediente: 0,
            IdRadicadoEntrada: 0,
            IdRadicadoSalida: 0,
            Nombre: file.name,
            NombreArchivo: `${nombre}.${extension}`,
            Extension: extension,
            Length: file.size,
            Archivo: file,
            Tipo: file.type,
            PreventRemove: false,
          });

          files.push(file);

        }

      }

      // Actualiar estado
      this.setState({ items });

      if (this.props.onChange) {
        this.props.onChange(items);
      }

      // Ejecutar evento
      if (this.props.onDrop) {
        this.props.onDrop(files);
      }

      if (errorMessage !== '') {
        showError(errorMessage)
      }

    }

  }

  private _onDragOver(e: React.DragEvent<HTMLDivElement>) {
    e.preventDefault();
    e.stopPropagation();
  }

  private _defaultState(): IDropZoneComponentState {

    const columns = this.props.columns && this.props.columns.length > 0 ? this.props.columns : [
      {
        key: 'Name',
        name: 'Nombre',
        fieldName: 'Nombre',
        minWidth: 300,
        maxWidth: 400,
        isResizable: true,
        onRender: this._onRenderName.bind(this)
      },
      {
        key: 'Extension',
        name: 'Extensión',
        fieldName: 'Extension',
        minWidth: 150,
        maxWidth: 180,
        isResizable: true
      },
      {
        key: 'Length',
        name: 'Tamaño',
        fieldName: 'Length',
        minWidth: 60,
        maxWidth: 100,
        isResizable: true,
        onRender: (o: IDocumento) => `${truncate((o.Length / 1024))} Kb`
      },
      {
        key: 'Delete',
        name: '',
        fieldName: 'Delete',
        minWidth: 80,
        maxWidth: 80,
        isResizable: false,
        onRender: this._onRenderDeleteIcon.bind(this)
      }
    ];

    return {
      style: {
        padding: '25px',
        border: 'dashed 1px gray',
        textAlign: 'center'
      },
      items: this.props.items || [],
      defaultColumns: columns,
      customColumns: this.props.columns || [],
      allowedExtensions: [],
      maxLength: 1024
    };

  }

  private _onRenderName(item: IDocumento): JSX.Element {
    const allowRemove = this.props.onAllowRemove(item);
    if (item.IdDocumentoExpediente > 0 || (item.ServerRelativeUrl !== undefined && item.ServerRelativeUrl !== '')) {
      return <Link onClick={() => {
        if (this.props.onItemClick) {
          this.props.onItemClick(item);
        }
      }}>{item.Nombre}</Link>;
    }
    else {
      return <span>{item.Nombre}</span>;
    }
  }

  private _onRenderDeleteIcon(item: IDocumento): JSX.Element {
    const allowRemove = this.props.onAllowRemove(item);
    if (!this.props.disabled) {
      return <TooltipHost content='Eliminar archivo'>
        <div style={{ textAlign: 'center' }}>
          <Icon iconName='Cancel' style={{ fontSize: '16px', paddingTop: '8px', color: 'red', cursor: 'pointer' }} onClick={() => {
            const items = this.state.items.filter(o => o !== item);
            this.setState({ items });
            if (this.props.onChange) {
              this.props.onChange(items);
            }
          }} />
        </div>
      </TooltipHost>
    } else {
      return <span></span>
    }
  }
}

//#region DataTable
